import React from 'react';
import ImageElement from './ImageElement';
import { AssetBase } from '../../types';

type Props = {
  onAdd?: () => void;
  items: AssetBase[];
};

const Gallery = ({ onAdd, items }: Props) => {
  return (
    <div className='w-full'>
      <div className='scrollbar-hide flex flex-row gap-1 overflow-x-auto'>
        {items &&
          items.map((item, index) => <ImageElement key={index} asset={item} />)}

        {onAdd && <ImageElement onAdd={onAdd} />}
      </div>
    </div>
  );
};

export default Gallery;
